var $ = require('jquery');

$(document).ready(function() {
    initColumn();
})
function initColumn() {
    $('.page-section--main .wp-block-column.is-style-clickable').on('click', function() {
        var link = $(this).find('.wp-block-button__link');
        if(link.length != 0) {
            $(link)[0].click();
        }
    })
}
